import { render } from "./Furniture.vue?vue&type=template&id=40f6da2c"
import script from "./Furniture.vue?vue&type=script&lang=js"
export * from "./Furniture.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__